module.exports = __webpack_public_path__ + "static/38348692190b315c201c6a882c9cdc6e417c0f89588a5ddb3137f2fb124b2f7a-aad0d2fdca70c71486bf58305f22a41a.png";